<template>
    <footer class="site-footer" id="contacto">
        <div class="footer-inner">
            <div class="footer-brand">
                <a class="footer-logo" href="#">Funko Pop Morelia</a>
                <p>Figuras Funko Pop, ediciones especiales y favoritos de colección.</p>
            </div>

            <div class="footer-trust" aria-label="Confianza y referencias">
                <p>Más de 9 años vendiendo Funkos originales. Entregamos cajas y figuras en excelentes condiciones.</p>
                <div class="footer-trust-links">
                    <span>Referencias:</span>
                    <a
                        href="https://www.facebook.com/funkoPopMorelia/reviews/?id=100063817933186&sk=reviews"
                        target="_blank"
                        rel="noreferrer"
                    >Fanpage</a>
                    <a
                        href="https://www.facebook.com/marketplace/profile/1413103788/"
                        target="_blank"
                        rel="noreferrer"
                    >Marketplace</a>
                </div>
            </div>

            <div class="footer-columns">
                <section>
                    <h3>Compra</h3>
                    <a
                        class="footer-catalog-primary"
                        href="https://catalogo.funkopopmorelia.com.mx/"
                        target="_blank"
                        rel="noreferrer"
                    >Catálogo</a>
                    <a
                        href="https://catalogo.funkopopmorelia.com.mx/masNuevo"
                        target="_blank"
                        rel="noreferrer"
                    >Novedades</a>
                    <a
                        href="https://catalogo.funkopopmorelia.com.mx/menorPrecio"
                        target="_blank"
                        rel="noreferrer"
                    >Menor precio</a>
                    <a
                        href="https://catalogo.funkopopmorelia.com.mx/promo-200"
                        target="_blank"
                        rel="noreferrer"
                    >Promoción</a>
                    <a
                        href="https://catalogo.funkopopmorelia.com.mx/preventas"
                        target="_blank"
                        rel="noreferrer"
                    >Preventas</a>
                    <a
                        class="footer-discounts-link"
                        href="https://catalogo.funkopopmorelia.com.mx/descuentos"
                        target="_blank"
                        rel="noreferrer"
                    >Descuentos</a>
                </section>

                <section>
                    <h3>Contacto</h3>
                    <a
                        class="social-link social-link-whatsapp"
                        href="https://wa.me/524431104022"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span class="social-icon" aria-hidden="true">
                            <i class="fab fa-whatsapp"></i>
                        </span>
                        <span>WhatsApp</span>
                    </a>
                </section>

                <section>
                    <h3>Redes sociales</h3>
                    <a
                        class="social-link social-link-instagram"
                        href="https://www.instagram.com/funkopopmorelia"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span class="social-icon" aria-hidden="true">
                            <i class="fab fa-instagram"></i>
                        </span>
                        <span>Instagram</span>
                    </a>
                    <a
                        class="social-link social-link-facebook"
                        href="https://www.facebook.com/funkoPopMorelia"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <span class="social-icon" aria-hidden="true">
                            <i class="fab fa-facebook-f"></i>
                        </span>
                        <span>Facebook</span>
                    </a>
                </section>
            </div>

            <div class="footer-bottom">
                <p>&copy; {{ currentYear }} Funko Pop Morelia. Todos los derechos reservados.</p>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: "Footer",
    computed: {
        currentYear(){
            return new Date().getFullYear();
        }
    }
}
</script>

<style lang="scss" scoped>
    .site-footer {
        background:
            linear-gradient(180deg, rgba(5, 7, 9, 0.82), rgba(5, 7, 9, 0.9)),
            url("~@/assets/header-assets/brush6.webp"),
            url("~@/assets/header-assets/brush5.webp"),
            url("~@/assets/header-assets/noise.svg"),
            #050607;
        background-position: center, left top, right top, center;
        background-repeat: no-repeat, no-repeat, no-repeat, repeat;
        background-size: auto, min(36vw, 460px) 115%, min(36vw, 460px) 115%, auto;
        border-top: 2px solid rgba(255, 255, 255, 0.16);
        color: #ffffff;
        margin-left: calc(50% - 50vw);
        margin-right: calc(50% - 50vw);
        margin-top: 2.5rem;
        padding: 2.25rem 0 1.5rem;
        position: relative;
    }

    .footer-inner {
        margin: 0 auto;
        padding-left: 1.5rem;
        padding-right: 1.5rem;
        width: 100%;
    }

    .footer-brand {
        align-items: flex-end;
        border-bottom: 1px solid rgba(255, 255, 255, 0.09);
        display: flex;
        gap: 1.5rem;
        justify-content: space-between;
        padding-bottom: 1.35rem;
    }

    .footer-logo {
        color: #0b94cf;
        font-size: 1.3rem;
        font-weight: 600;
        letter-spacing: 0.02em;
        line-height: 1;
        text-decoration: none;
        text-transform: none;
    }

    .footer-brand p {
        color: rgba(255, 255, 255, 0.7);
        font-size: 0.95rem;
        line-height: 1.55;
        margin: 0;
        max-width: 34rem;
    }

    .footer-trust {
        align-items: center;
        border-bottom: 1px solid rgba(255, 255, 255, 0.09);
        color: rgba(255, 255, 255, 0.7);
        display: flex;
        font-size: 0.95rem;
        gap: 1rem;
        justify-content: space-between;
        line-height: 1.5;
        padding: 1.1rem 0;
    }

    .footer-trust p {
        margin: 0;
        max-width: 44rem;
    }

    .footer-trust-links {
        align-items: center;
        color: rgba(255, 255, 255, 0.64);
        display: inline-flex;
        flex-wrap: wrap;
        gap: 0.55rem;
        justify-content: flex-end;
        white-space: nowrap;
    }

    .footer-trust-links a {
        color: #18bdf4;
        font-weight: 700;
        text-decoration: underline;
        text-decoration-color: rgba(24, 189, 244, 0.34);
        text-underline-offset: 0.18em;
    }

    .footer-trust-links a:hover {
        color: #ffffff;
        text-decoration-color: rgba(24, 189, 244, 0.72);
    }

    .footer-columns {
        display: grid;
        gap: clamp(1.25rem, 4vw, 3rem);
        grid-template-columns: repeat(3, minmax(0, 1fr));
        padding: 1.8rem 0;
    }

    .footer-columns section {
        align-content: start;
        display: grid;
        gap: 0.8rem;
    }

    .footer-columns h3 {
        color: #ffd84d;
        font-size: 0.95rem;
        letter-spacing: 0.08em;
        margin: 0;
        text-transform: uppercase;
    }

    .footer-columns a {
        color: rgba(255, 255, 255, 0.74);
        text-decoration: none;
        transition: color 180ms ease, text-decoration-color 180ms ease;
        width: fit-content;
    }

    .footer-columns a:hover {
        color: #18bdf4;
    }

    .footer-catalog-primary {
        color: #ffffff !important;
        font-weight: 800;
    }

    .footer-discounts-link {
        font-weight: 800;
    }

    .footer-discounts-link:hover {
        color: #18bdf4;
    }

    .social-link {
        align-items: center;
        border-radius: 999px;
        color: rgba(255, 255, 255, 0.8);
        display: inline-flex;
        font-weight: 500;
        gap: 0.75rem;
        padding: 0.2rem 0.45rem 0.2rem 0.2rem;
        transition: color 180ms ease, background 180ms ease;
        width: fit-content;
    }

    .social-icon {
        align-items: center;
        border-radius: 50%;
        color: #ffffff;
        display: inline-flex;
        flex-shrink: 0;
        font-size: 1rem;
        font-weight: 900;
        height: 2rem;
        justify-content: center;
        width: 2rem;
    }

    .social-icon i {
        font-size: 1rem;
        line-height: 1;
    }

    .social-link-instagram .social-icon {
        background: linear-gradient(135deg, #f9ce34 0%, #ee2a7b 52%, #6228d7 100%);
    }

    .social-link-facebook .social-icon {
        background: linear-gradient(180deg, #1877f2 0%, #0d5fd3 100%);
    }

    .social-link-whatsapp .social-icon {
        background: linear-gradient(180deg, #25d366 0%, #128c4a 100%);
    }

    .social-link:hover {
        background: rgba(255, 255, 255, 0.08);
        color: #ffffff;
    }

    .footer-bottom {
        border-top: 1px solid rgba(255, 255, 255, 0.09);
        color: rgba(255, 255, 255, 0.58);
        display: flex;
        font-size: 0.86rem;
        gap: 1rem;
        justify-content: space-between;
        padding-top: 1.15rem;
    }

    .footer-bottom p {
        margin: 0;
    }

    @media (max-width: 920px) {
        .site-footer {
            background-size: auto, 320px 112%, 320px 112%, auto;
        }

        .footer-columns {
            grid-template-columns: 1fr;
        }

        .footer-trust {
            align-items: flex-start;
            flex-direction: column;
        }

        .footer-trust-links {
            justify-content: flex-start;
            white-space: normal;
        }
    }

    @media (max-width: 767px) {
        .footer-brand,
        .footer-bottom {
            align-items: flex-start;
            flex-direction: column;
        }
    }
</style>
